import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '@/lib/firebase';

export interface MaintenanceConfig {
  enabled: boolean;
  message?: string;
  estimatedDuration?: string;
  lastUpdated: Date;
  updatedBy?: string;
}

/**
 * Subscribe to real-time maintenance config updates
 */
export const subscribeToMaintenanceConfig = (
  callback: (config: MaintenanceConfig) => void
): (() => void) => {
  const maintenanceRef = doc(db, 'config', 'maintenance');
  
  return onSnapshot(maintenanceRef, (doc) => {
    if (doc.exists()) {
      const data = doc.data();
      const config: MaintenanceConfig = {
        enabled: data.enabled || false,
        message: data.message || 'We are currently performing scheduled maintenance. Please check back soon.',
        estimatedDuration: data.estimatedDuration || 'a few minutes',
        lastUpdated: data.lastUpdated?.toDate() || new Date(),
        updatedBy: data.updatedBy
      };
      callback(config);
    } else {
      // Default config if document doesn't exist
      const defaultConfig: MaintenanceConfig = {
        enabled: false,
        message: 'We are currently performing scheduled maintenance. Please check back soon.',
        estimatedDuration: 'a few minutes',
        lastUpdated: new Date()
      };
      callback(defaultConfig);
    }
  }, (error) => {
    console.error('Error in maintenance config subscription:', error);
    // On error, assume maintenance mode is disabled
    callback({
      enabled: false,
      message: 'We are currently performing scheduled maintenance. Please check back soon.',
      estimatedDuration: 'a few minutes',
      lastUpdated: new Date()
    });
  });
}; 